import { useEffect } from 'react';
import { useToast } from '@/components/toast/useToast';

const useShowToast = ({
  isSuccess,
  isError,
  successMessage,
  errorMessage,
  callbackSuccess,
}: {
  isSuccess: boolean;
  isError: boolean;
  successMessage: string;
  errorMessage: string;
  callbackSuccess: () => void;
}) => {
  const { toast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      toast({ description: successMessage, variant: 'success' });
      callbackSuccess();
    } else if (isError) {
      toast({
        description: errorMessage,
      });
    }
  }, [isSuccess, toast, callbackSuccess, isError, successMessage, errorMessage]);
};

export default useShowToast;
